import { WholesaleCustomer } from "../features/wholesale/pages/wholesale-customer"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function WholesaleCustomerPage() {
  return (
    <DashboardLayout>
      <WholesaleCustomer />
    </DashboardLayout>
  )
}
